import { ESpineRenderType } from "../SpineSkeleton";
export class SlotUtils {
    static checkAttachment(attachment) {
        if (attachment == null)
            return ESpineRenderType.rigidBody;
        if (attachment instanceof window.spine.RegionAttachment) {
            return ESpineRenderType.rigidBody;
        }
        else if (attachment instanceof window.spine.MeshAttachment) {
            let mesh = attachment;
            if (!mesh.bones) {
                return ESpineRenderType.rigidBody;
            }
            else {
                return ESpineRenderType.boneGPU;
            }
        }
        else {
            return ESpineRenderType.normal;
        }
    }
    static appendIndexArray(attachmentParse, indexArray, size, offset) {
        if (!attachmentParse.attachment || !attachmentParse.indexArray)
            return offset;
        let slotindexArray = attachmentParse.indexArray;
        for (let j = 0, n = slotindexArray.length; j < n; j++) {
            indexArray[offset] = slotindexArray[j] + size;
            offset++;
        }
        return offset;
    }
}
